<div class="vai-container">
  <div class="vai-bars w-100">
    <div *ngFor="let h of barHeights; let i = index" class="vai-bar-vert" [style.height.%]="h" [style.opacity]="active ? 1 : 0.5"></div>
  </div>
</div>
